module.exports = __webpack_public_path__ + "img/b4-4.78427af.png";